import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { apis } from '../config/api';

export type MediaType = 'profile' | 'logo' | 'product';

export interface UploadedFile {
  url: string;
  path: string;
  filename: string;
  originalName: string;
  mimeType: string;
  size: number;
  type: MediaType;
}

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  http = inject(HttpClient);

  url = apis.media;

  uploadSingle(file: File, type: MediaType): Observable<UploadedFile> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http
      .post<{ data: { file: UploadedFile } }>(`${this.url}/upload/${type}`, formData)
      .pipe(map((res) => res.data.file));
  }

  uploadMany(files: File[], type: MediaType): Observable<UploadedFile[]> {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return this.http
      .post<{ data: { files: UploadedFile[] } }>(`${this.url}/upload-many/${type}`, formData)
      .pipe(map((res) => res.data.files));
  }
}
